export async function loader({ request }) {
  const url = new URL(request.url);
  const storeId =
    url.searchParams.get("store_id") || sessionStorage.getItem("storeId");
  const integratorId =
    url.searchParams.get("pos_integrator_id") ||
    sessionStorage.getItem("integratorId");
  const token =
    url.searchParams.get("token") || sessionStorage.getItem("token");
  const callbackUrl =
    url.searchParams.get("callback_url") ||
    sessionStorage.getItem("callbackUrl");

  sessionStorage.setItem("token", token);
  sessionStorage.setItem("integratorId", integratorId);
  sessionStorage.setItem("storeId", storeId);
  sessionStorage.setItem("callbackUrl", callbackUrl);

  return { storeId, integratorId, token, callbackUrl };
}
